// @flow
import React from 'react';

import { CSSTransition } from 'react-transition-group';

import styles from './error.css';


type ErrorElementType = {
  title: string
};

type ErrorListPropTypes = {
  errors: Array<ErrorElementType>,
  className?: string
};

const ErrorList = ({
  className = '',
  errors = [],
}: ErrorListPropTypes) => (
  <CSSTransition
    in={errors.length > 0}
    timeout={200}
    classNames={styles}
    unmountOnExit
  >
    <div
      className={
        `
          ${styles.error}
          ${className}
        `
      }
    >
      {
        errors.map(
          ({ title = '' }) => (
            <div className={styles.title} key={title}>
              { title }
            </div>
          ),
        )
      }
    </div>
  </CSSTransition>
);

export default ErrorList;



// WEBPACK FOOTER //
// ./src/scripts/components/ErrorList/index.jsx